import { render, staticRenderFns } from "./slide-x.vue?vue&type=template&id=bcf80666&scoped=true&"
import script from "./slide-x.vue?vue&type=script&lang=js&"
export * from "./slide-x.vue?vue&type=script&lang=js&"
import style0 from "./slide-x.vue?vue&type=style&index=0&id=bcf80666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf80666",
  null
  
)

export default component.exports